export const role_distributor_rules_en = [
  // Page 1: Game Introduction & Basic Rules
  "Host sets roles and randomly assigns them to participants.",
  "Host",
  "Can directly input roles and specify quantities.",
  "Participants",
  "Can only see their assigned role.",

  // Page 2: Role System
  "Basic Role",
  "Must exist, assigned to remaining players.",
  "Special Roles",
  "Host can add custom roles and set quantities.",
  "Random Assignment",
  "Roles are randomly distributed to users at start.",

  // Page 3: Game Settings & Tips
  "Game Settings & Tips",
  "Moderator Mode",
  "Host can see assignment results.",
  "Action System",
  "Each role can be assigned actions. When the host activates actions, players can use them. When the host ends the action phase, the action usage results for that phase are revealed.",
  // Page 4: Available Actions
  "Available Actions",
  "Assassinate: Eliminate another player",
  "Protect: Shield another player from harm",
  "Investigate: Reveal another player's identity",
  "Public Nomination: Publicly nominate another player",
  "Secret Nomination: Nominate another player (only totals revealed)",
  "Public Vote: Vote for/against proposal (choices revealed)",
  "Secret Vote: Vote for/against proposal (only totals revealed)",
  "Mafia Game Usage Example",
  "When the moderator participates in the game, it can proceed as follows:",
  "Grant Nomination and Public Vote actions to all roles",
  "Mafia: Add Assassinate action, Doctor: Add Protect action, Police: Add Investigate action",
  "Night Phase: Activate actions → Mafia/Doctor/Police use actions → Complete action usage",
  "Day Phase: Check night action results, then activate actions → Survivors use nomination actions → Complete action usage",
  "Vote Phase: Check day nomination results, then activate actions → Use vote actions → Complete action usage",
  "For offline play, you can flexibly use only private actions like the night phase through the app, while conducting day actions in person.",

  // Page 5: Avalon Guide
  "Avalon Guide",
  "A social deduction game where Good and Evil compete through quests and deduction.",
  "Game Overview",
  "Good players must succeed quests, while Evil players try to sabotage them. Good wins if 3 quests succeed. Evil wins if 3 quests fail or by assassinating Merlin at the end.",
  "Good Faction",
  "Merlin",
  "Knows Evil players (except Mordred) but risks being assassinated if revealed.",
  "Percival",
  "Sees both Merlin and Morgana but can't tell them apart.",
  "Loyal Servant",
  "A Good player with no special information.",
  "Evil Faction",
  "Mordred",
  "An Evil player invisible to Merlin.",
  "Morgana",
  "An Evil player who appears as Merlin to Percival.",
  "Assassin",
  "Can assassinate a player at game end if Evil has lost.",
  "Oberon",
  "Unknown to other Evil players and doesn't know them.",
  "Minion of Mordred",
  "An Evil player with no special abilities.",
  "Action Usage",
  "Public Nomination: Quest leader selects team members for the quest",
  "Public Vote: Vote to approve/reject the leader's team selection",
  "Secret Vote: Quest members choose Success (Approve) or Fail (Reject)",
  "See Roles: Merlin sees evil (except Mordred), Evil sees each other (except Oberon), Percival sees Merlin/Morgana",
  "Recommended Setup",
  "5 players: Merlin, Percival, 2 Loyal Servants, Morgana, Assassin",
  "6 players: + 1 Loyal Servant",
  "7 players: + Oberon or Mordred",
  "8-10 players: Add more Loyal Servants and Evil characters as needed",

  // Page 6: Mafia Guide
  "Mafia Guide",
  "A classic social deduction game where citizens must identify and eliminate mafia members.",
  "Game Overview",
  "Mafia members try to eliminate citizens at night, while citizens use discussion and voting to eliminate mafia during the day. Citizens win by eliminating all mafia. Mafia wins when they equal or outnumber citizens.",
  "Citizen Faction",
  "Citizen",
  "A good player with no special abilities. Must use logic and discussion.",
  "Police",
  "Can investigate one player each night to learn their identity.",
  "Doctor",
  "Can protect one player each night from mafia attacks.",
  "Mafia Faction",
  "Mafia",
  "Knows all other mafia members. Can eliminate one citizen each night.",
  "Gameplay Flow",
  "1. Night Phase: Players close eyes. Mafia wakes and chooses a victim. Police investigates. Doctor protects.",
  "2. Day Phase: Victim is revealed. Discussion and debate. Players nominate and vote to eliminate someone.",
  "3. Repeat until one side wins.",
  "Action System Usage",
  "Night: Activate actions → Mafia uses assassinate, Doctor uses protect, Police uses investigate → End actions to reveal results",
  "Day: Discussion → Activate actions → All players use nominate action → End actions to see nominations → Vote phase",
  "Recommended Setup",
  "7 players: 2 Mafia, 1 Police, 1 Doctor, 3 Citizens",
  "9 players: 2 Mafia, 1 Police, 1 Doctor, 5 Citizens",
  "12+ players: 3 Mafia, 1 Police, 1 Doctor, remaining Citizens",
  // Additional actions
  "See Roles: View players with selected roles (multiple selections show names without role matching)",
];

export const role_distributor_rules_ko = [
  // Page 1: 게임 소개 및 기본 규칙
  "방장이 설정한 역할을 참가자들에게 랜덤으로 배정해줍니다.",
  "방장",
  "역할을 직접 입력하고, 수량을 지정할 수 있습니다.",
  "참가자",
  "본인에게 배정된 역할만 확인할 수 있습니다.",

  // Page 2: 역할 시스템
  "기본 역할",
  "반드시 1개 존재하며, 남은 인원에게 자동 배분됩니다.",
  "특수 역할",
  "방장이 원하는 역할을 추가하고, 수량을 설정할 수 있습니다.",
  "랜덤 배정",
  "시작 시 역할이 랜덤하게 유저에게 배정됩니다.",

  // Page 3: 게임 설정 및 팁
  "게임 설정 & 팁",
  "사회자 모드",
  "방장이 배정 결과를 확인할 수 있습니다.",
  "액션 시스템",
  "각 역할에 액션을 부여할 수 있습니다. 방장이 액션을 활성화하면 플레이어들이 액션을 사용한 후, 방장이 액션 사용을 종료하면 해당 페이즈의 액션 사용 결과가 공개됩니다.",
  // Page 4: 사용 가능한 액션들
  "사용 가능한 액션",
  "암살: 다른 플레이어를 제거",
  "보호: 다른 플레이어를 보호",
  "조사: 다른 플레이어의 정체 확인",
  "공개 지목: 다른 플레이어를 공개적으로 지목",
  "비공개 지목: 다른 플레이어를 지목 (득표수만 공개)",
  "공개 찬반투표: 안건에 대해 찬반 투표 (개별 선택 공개)",
  "비공개 찬반투표: 안건에 대해 찬반 투표 (총계만 공개)",
  "마피아 게임 활용 예제",
  "사회자가 게임에 참여할 경우 다음과 같이 진행할 수 있습니다.",
  "모든 직업에 지목, 공개 찬반투표 액션 부여",
  "마피아: 암살 액션 추가, 의사: 보호 액션 추가, 경찰: 조사 액션 추가",
  "밤 페이즈: 액션 활성화 → 마피아/의사/경찰 액션 사용 → 액션 사용 완료",
  "낮 페이즈: 밤의 액션 결과 확인 후 액션 활성화 → 생존자는 지목 액션 사용 → 액션 사용 완료",
  "찬반투표: 낮의 지목 결과 확인 후 액션 활성화 → 찬반투표 액션 사용 → 액션 사용 완료",
  "오프라인 진행 시 밤 페이즈와 같은 비공개 액션만 앱으로 진행하고, 낮 이후의 액션은 실제로 진행하는 등 유동적으로 활용할 수 있습니다.",

  // Page 5: 아발론 가이드
  "아발론 가이드",
  "선과 악이 퀘스트와 추리를 통해 경쟁하는 소셜 디덕션 게임입니다.",
  "게임 개요",
  "선 진영은 퀘스트를 성공시켜야 하고, 악 진영은 퀘스트를 실패시켜야 합니다. 퀘스트 3개 성공 시 선 승리. 퀘스트 3개 실패 또는 멀린 암살 성공 시 악 승리.",
  "선 진영",
  "멀린",
  "모드레드를 제외한 악의 세력을 알고 있지만, 정체가 드러나면 암살당할 위험이 있습니다.",
  "퍼시벌",
  "멀린과 모르가나를 볼 수 있지만, 둘 중 누가 진짜 멀린인지 구별할 수 없습니다.",
  "충신",
  "특별한 정보가 없는 선의 세력입니다.",
  "악 진영",
  "모드레드",
  "멀린에게 보이지 않는 악의 세력입니다.",
  "모르가나",
  "퍼시벌에게 멀린처럼 보이는 악의 세력입니다.",
  "암살자",
  "게임 종료 시 악이 패배했다면 멀린을 암살할 수 있습니다.",
  "오베론",
  "다른 악의 세력을 알 수 없고, 다른 악의 세력도 오베론을 알 수 없습니다.",
  "미니언",
  "특별한 능력이 없는 악의 세력입니다.",
  "액션 사용법",
  "공개 지목: 원정대장이 함께 갈 인원을 고릅니다",
  "공개 찬반: 원정대장의 인원 선정에 찬성/반대를 투표합니다",
  "비공개 찬반: 원정에 간 인원이 성공(찬성)/실패(반대)를 선택합니다",
  "역할 확인: 멀린은 모드레드 제외 악인 확인, 악팀은 오베론 제외 악인 확인, 퍼시벌은 멀린/모르가나 확인",
  "추천 구성",
  "5인: 멀린, 퍼시벌, 충신 2명, 모르가나, 암살자",
  "6인: + 충신 1명",
  "7인: + 오베론 또는 모드레드",
  "8-10인: 필요에 따라 충신과 악 캐릭터 추가",

  // Page 6: 마피아 가이드
  "마피아 가이드",
  "시민들이 마피아를 찾아내고 제거해야 하는 고전 소셜 디덕션 게임입니다.",
  "게임 개요",
  "마피아는 밤에 시민을 제거하고, 시민은 낮의 토론과 투표로 마피아를 제거합니다. 시민은 모든 마피아를 제거하면 승리. 마피아는 시민과 동수 이상이 되면 승리.",
  "시민 진영",
  "시민",
  "특별한 능력이 없는 선량한 시민입니다. 논리와 토론으로 마피아를 찾아야 합니다.",
  "경찰",
  "매일 밤 한 명을 조사하여 정체를 알 수 있습니다.",
  "의사",
  "매일 밤 한 명을 마피아의 공격으로부터 보호할 수 있습니다.",
  "마피아 진영",
  "마피아",
  "다른 모든 마피아를 알고 있습니다. 매일 밤 시민 한 명을 제거할 수 있습니다.",
  "게임 진행",
  "밤 단계: 모두 눈을 감음. 마피아가 일어나 희생자 선택. 경찰 조사. 의사 보호.",
  "낮 단계: 희생자 공개. 토론 및 논쟁. 투표로 한 명 제거.",
  "한 진영이 승리할 때까지 반복.",
  "액션 시스템 활용",
  "밤: 액션 활성화 → 마피아는 암살, 의사는 보호, 경찰은 조사 → 액션 종료로 결과 공개",
  "낮: 토론 → 액션 활성화 → 모든 플레이어가 지목 액션 사용 → 액션 종료로 지목 결과 확인 → 투표",
  "추천 구성",
  "7인: 마피아 2명, 경찰 1명, 의사 1명, 시민 3명",
  "9인: 마피아 2명, 경찰 1명, 의사 1명, 시민 5명",
  "12인 이상: 마피아 3명, 경찰 1명, 의사 1명, 나머지 시민",
  // 추가 액션
  "역할 확인: 선택한 역할을 가진 플레이어들을 확인합니다 (여러 역할 선택 시 누가 어떤 역할인지는 비공개)",
];
